<template>
  <div id="newboard" class="flexCenterCol">
    <div class="newQBox">
      <h1 style="text-align: center">{{ this.qnalist[curstep].question }}</h1>
      <div class="flexCenterRow">
        <div
          v-for="option in this.qnalist[curstep].options"
          :key="option"
          class="optionBox"
          @click="selectOption(this.qnalist[curstep], option)"
        >
          <!-- <LayoutDashboard style="margin-bottom: 15px" stroke-width="1.5" /> -->
          <component
            :is="option.icon"
            style="margin-bottom: 15px"
            stroke-width="1.5"
          />
          <h3 style="margin-bottom: 7px">{{ option.title }}</h3>
          <p>{{ option.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
// import SideNav from "../../../components/utilities/SideNav.vue";
import {
  Compass,
  DiamondPlus,
  Binoculars,
  Map,
  Microscope,
  FileTerminal,
  BrickWall,
  Shrub,
} from "lucide-vue-next";
import { useBoardStore } from "@/stores/boardStore.js";

export default {
  name: "NewBoard",
  components: {},
  methods: {
    selectOption(question, option) {
      // console.log("Selected option:", question, option);
      this.boardConfig[question.step] = option.title
        .toLowerCase()
        .split(" ")[0];

      if (this.curstep + 1 >= this.qnalist.length) {
        // console.log("Finished");
        const boardStore = useBoardStore();
        boardStore.setBoardConfig(this.boardConfig);

        this.$router.push({
          name: "Workboards",
          // params: {
          //   boardConfig: JSON.stringify(this.boardConfig),
          // },
        });
      } else {
        this.curstep++;
      }
    },
  },
  beforeUnmount() {},
  setup() {
    return {};
  },
  data() {
    return {
      // Compass,
      curstep: 0,
      // Binoculars,
      // DiamondPlus,
      // Compass,
      boardConfig: {
        action: "",
        detail: "",
        user_type: "",
        existing_tools: "",
      },
      qnalist: [
        {
          step: "action",
          question: "What would you like to do?",
          options: [
            {
              icon: Binoculars,
              title: "Visualize",
              text: "Visualize your current workflow",
            },
            {
              icon: DiamondPlus,
              title: "Improve",
              text: "Improve an inefficient workflow",
            },
            {
              icon: Compass,
              title: "Discover",
              text: "Discover new tools and workflows",
            },
          ],
        },
        {
          step: "detail",
          question: "At what level of detail?",
          options: [
            {
              icon: Map,
              title: "Strategic",
              text: "High-level strategic workflows",
            },
            {
              icon: Microscope,
              title: "Operational",
              text: "Precise low-level workflows for ops",
            },
            {
              icon: FileTerminal,
              title: "Execution",
              text: "Precise low-level workflows for execution",
            },
          ],
        },
        {
          step: "user_type",
          question: "What is your current role?",
          options: [
            {
              icon: BrickWall,
              title: "Partner",
              text: "Partner or executive at your current company",
            },
          ],
        },
        {
          step: "existing_tools",
          question:
            "Do you want to build a stack with existing tools or new ones?",
          options: [
            {
              icon: BrickWall,
              title: "Existing tools",
              text: "Only use tools you're already using",
            },
            {
              icon: Shrub,
              title: "New tools",
              text: "Suggest new or replacement tools to use",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
#newboard {
  position: absolute;
  left: 51px;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f9f4ff;
}
.newQBox {
  width: 600px;
  margin-bottom: 100px;
}
.optionBox {
  background: white;
  border-radius: 7px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  width: 200px;
  border: thin solid lightgray;
}
.optionBox:hover {
  background: #f0e5ff;
  border: thin solid #d3c2ff;
}
</style>
